import { makeStyles } from 'tss-react/mui';

export const useProductDetailsMassActionBarStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 44,
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(1.5),
    backgroundColor: theme.palette.accent.dark,
    borderRadius: theme.shape.borderRadiusLg,
    boxShadow: theme.shadows[4],
  },
  pasteToAllButton: {
    border: 'none',
    fontSize: theme.typography.body2.fontSize,
  },
}));
